import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Handles root path redirect based on subdomain detection.
 * On clinic subdomains (e.g., smithclinic.seebaby.ai), redirects to the booking page.
 * On app.seebaby.ai, redirects to home (normal behavior).
 */
@Component({
  selector: 'app-subdomain-redirect',
  template: '',
  standalone: true,
})
export class SubdomainRedirectComponent implements OnInit {
  private static readonly RESERVED = new Set([
    'app', 'admin', 'www', 'api', 'media', 'webmail', 'ssh', 'mail',
    'cdn',
  ]);

  constructor(private router: Router) {}

  ngOnInit(): void {
    const slug = this.getClinicSlug();
    if (slug) {
      this.router.navigate(['/booking', slug]);
    } else {
      this.router.navigate(['/login']);
    }
  }

  private getClinicSlug(): string | null {
    const hostname = window.location.hostname;
    const match = hostname.match(/^([a-z0-9-]+)\.seebaby\.ai$/);
    if (match && !SubdomainRedirectComponent.RESERVED.has(match[1])) {
      return match[1];
    }
    return null;
  }
}
